import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "df-banner" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 1,
    class: "df-banner__glow"
};
import { computed } from "vue";
import { useDonation } from "../../context/donationContext";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationBanner',
    setup(__props) {
        /**
         * DonationBanner — the hero header. SYNC: see ../../_SYNC.md.
         *
         * Renders the tenant header image when `branding.bannerImageUrl` is set, else an
         * accent radial glow, layered with a scrim. The document carries NO banner copy
         * (org/tag/title) — the human-facing step title is carried by StepShell — so the
         * banner is purely visual branding. The image is decorative (`alt=""`).
         *
         * The image fills the band (`object-fit: cover`); `branding.bannerImagePosition`
         * chooses WHICH part of a wide upload survives the crop. It arrives as a static
         * modifier class rather than an inline style so no document-derived string ever
         * reaches the CSSOM, and the mapping is an exhaustive Record — a new position
         * token then fails to compile instead of silently rendering no modifier.
         */
        const { bannerImageUrl, bannerImagePosition } = useDonation();
        const POSITION_CLASS = {
            Left: "df-banner__img--left",
            Center: "df-banner__img--center",
            Right: "df-banner__img--right",
        };
        const showPhoto = computed(() => !!bannerImageUrl.value);
        const positionClass = computed(() => POSITION_CLASS[bannerImagePosition.value]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (showPhoto.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: _normalizeClass(["df-banner__img", positionClass.value]),
                        src: _unref(bannerImageUrl) ?? '',
                        alt: ""
                    }, null, 10 /* CLASS, PROPS */, _hoisted_2))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3)),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "df-banner__scrim" }, null, -1 /* CACHED */))
            ]));
        };
    }
});
